





































































import { Vue, Component, Prop } from 'vue-property-decorator';
import posed, { PoseTransition } from 'vue-pose';

import CoinAnatomy from '@/components/icons/CoinAnatomy.vue';
import CoinAnatomySafari from '@/components/icons/CoinAnatomySafari.vue';

import { baseAnimations } from '@/views/Onboarding/helpers';
import { BusinessOnboardingYourDigitalCoinsForm } from '@/models/business-onboarding';

import { isSafari } from '@/utils/is-safari';

@Component({
  components: {
    PoseTransition,
    Container: posed.div(baseAnimations()),
    CoinAnatomy,
    CoinAnatomySafari
  }
})
export default class YourDigitalCoinIlustra extends Vue {
  coinCustomizationFormData: BusinessOnboardingYourDigitalCoinsForm = this
    .$store.getters['businessOnboarding/getYourDigitalCoinForm'];

  get tPrefix() {
    return 'common.components.interactiveCoin';
  }

  get componentToRender() {
    return isSafari() ? 'CoinAnatomySafari' : 'CoinAnatomy';
  }

  triggerUploadImageComponent() {
    if (!this.coinCustomizationFormData.coinShowFront) {
      return;
    }

    const elementOfTrigger =
      this.coinCustomizationFormData.image &&
      this.coinCustomizationFormData.image.imageFile
        ? document.getElementById('image-upload-block-edit')
        : document.getElementById('image-upload-block');

    if (elementOfTrigger) {
      elementOfTrigger.click();
    }
  }
}
